import { PropsWithChildren, useRef, useState, useEffect } from "react";

import { FIRST_ISSUE_ID } from "../constants/ui";
import { useInteractiveBoardStore } from "../state";

import {
    SpotlightTargetProps,
    useSpotlightManager
} from "./spotlight-provider";
import { Pulse } from "./spotlight-pulse";

export const SpotlightTarget = ({
    name,
    children,
    pulseSize,
    speed,
    style
}: PropsWithChildren<SpotlightTargetProps>) => {
    const [{ isDemoComplete }] = useInteractiveBoardStore();
    const targetElement = useRef<HTMLDivElement | null>(null);
    const { targets, current } = useSpotlightManager();
    const [shouldPulse, setShouldPulse] = useState(false);

    useEffect(() => {
        if (targetElement) {
            targets?.set(name, targetElement);
        }
    }, [targetElement]);

    useEffect(() => {
        const addingDemoCardToBoard =
            name === FIRST_ISSUE_ID && !isDemoComplete; //this step doesn't have a spotlight but should pulse
        setShouldPulse(targetElement == current || addingDemoCardToBoard);
    }, [current, isDemoComplete, name]);

    return (
        <div css={style} ref={targetElement}>
            {shouldPulse ? (
                <Pulse radius={3} pulseSize={pulseSize} speed={speed}>
                    {children}
                </Pulse>
            ) : (
                children
            )}
        </div>
    );
};
